import $ from "jquery";

const Loading = (function() {
  var config = {
    DEFAULT_SELECTOR: 'body',
    visible: false,
    hiding: false,
    modal: false,
    mask: null,
    animation: null,
    innerLoading: null,
    activeEl: null,
    minTop: null,
    message: null
  };

  async function during(action, { $el, message } = {}) {
    show($el, message);
    try {
      return await action();
    } finally {
      hide();
    }
  }

  function show($el, message) {
    if ($el) {
      config.defaultMode = false;
    } else {
      config.defaultMode = true;
    }

    if (config.hiding) {
      _finishHiding();
    }

    if (!config.visible) {
      _setupActiveEl($el);
      _buildMask();
      _positionElements();
    }

    _updateMessage(message);
  }

  function hide(userCallback) {
    config.defaultMode = false;
    config.modal = false;
    _updateMessage(null);

    if (config.mask) {
      config.hiding = true;
      config.mask.fadeOut(100, function() {
        if (config.hiding) {
          _finishHiding();
        }

        _callback(userCallback);
      });
    }
  }

  return {
    get isVisible() { return config.visible && !config.hiding; },
    during:       during,
    show:         show,
    hide:         hide,
    getMask:      function() { return config.mask; },
    getAnimation: function() { return config.animation; },
    getTarget:    function() { return config.activeEl; },
    getMessage:   function() { return config.message; }
  };

  // Private

  function _finishHiding() {
    config.hiding = false;
    _updateListeners('off');
    _resetAnimationPosition();
    config.footer.css('z-index', config.footerZindex);
    config.visible = false;
  }

  function _callback(userCallback) {
    typeof userCallback === 'function' && userCallback();
  }

  function _buildMask() {
    if (!config.mask) {
      config.innerLoading = $(
        '<div class="loading-mask-inner">' +
          '<div class="loading-mask-animation spinner">' +
            '<div class="rect1"></div>' +
            '<div class="rect2"></div>' +
            '<div class="rect3"></div>' +
            '<div class="rect4"></div>' +
            '<div class="rect5"></div>' +
          '</div>' +
        '</div>'
      );

      config.mask = $("<div class='loading-mask'></div>").append(config.innerLoading);
      config.innerLoading.append("<div class='loading-mask-message'></div>");
      config.animation = config.mask.find('.loading-mask-inner');
      $('body').append(config.mask);
    }
  }

  function _updateMessage(message) {
    config.message = message || "";
    $(config.mask).find(".loading-mask-message").text(config.message);
  }

  function _positionElements() {
    _showMask();
    _updateListeners('on');
  }

  function _updateListeners(toggle) {
    $(window)[toggle]('resize', _reposition);
    $(window)[toggle]('scroll', _reposition);
  }

  function _showMask() {
    _checkForModal();
    _reposition();
    config.mask.fadeIn(100);
    config.visible = true;
  }

  function _checkForModal() {
    config.modal = $('.modal-backdrop').css('display') === 'block';

    if (config.modal) {
      config.mask.css('z-index', 1061);
    } else {
      config.mask.css('z-index', 1038);
      config.footer.css('z-index', 1039);
    }
  }

  function _reposition() {
    var targetCss = _buildTargetCss();

    if (targetCss.width > 0 && !config.defaultMode) {
      config.mask.css({
        position: 'fixed',
        top:             targetCss.top,
        left:            targetCss.left,
        right:           targetCss.right,
        width:           targetCss.width,
        height:          targetCss.height
      });
    } else {
      config.mask.css({
        'padding-top': $('#header').height(),
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100%',
        height: '100%'
      });
    }

    _positionAnimation();
  }

  function _buildTargetCss() {
    if (config.activeEl && config.activeEl[0]) {
      var rect = config.activeEl[0].getBoundingClientRect();
      var radius = config.activeEl.css('border-radius');

      return {
        top:             rect.top,
        left:            rect.left,
        right:           rect.right,
        width:           rect.width,
        height:          rect.height,
        'border-radius': radius
      };
    }
  }

  function _positionAnimation() {
    if (config.modal) {
      config.animation.css({
        position: 'absolute',
        top: (config.activeEl.height() / 2) - (config.animation.height() / 2)
      });
    } else {
      var headerHeight         = $('#header').height();
      var navbarHeight         = $('.navbar-default').height();
      var maskIsAboveFold      = parseInt(config.mask.css('top').replace('px', '')) <= navbarHeight;
      var animationIsOffscreen = $(window).scrollTop() >= headerHeight - navbarHeight;

      if (animationIsOffscreen && maskIsAboveFold) {
        _fixAnimationToTop();
      } else {
        _resetAnimationPosition();
      }
    }
  }

  function _fixAnimationToTop() {
    config.animation.css({
      position: 'fixed',
      top: $('.navbar-default').height() + (config.mask.height() * (_getAnimationPercent() / 100))
    });
  }

  function _getAnimationPercent() {
    if (config.defaultMode) {
      return 14;
    } else if (config.modal) {
      return 14;
    } else {
      // 25;
    }
  }

  function _resetAnimationPosition() {
    config.animation.css({
      position: 'relative',
      top: _getAnimationPercent() + '%'
    });
  }

  function _setupActiveEl($el) {
    var target = $($el);
    var minWidth = 100;
    var minHeight = 40;
    var meetsSizeRequirements = (target.width() > minWidth) && (target.height() > minHeight);
    var parentModal = target.parents('.modal-dialog');

    config.footer = $('#footer');
    config.footerZindex = config.footer.css('z-index');

    if (config.modal && parentModal.length) {
      config.activeEl = parentModal;
    } else if (target.length > 0 && meetsSizeRequirements) {
      config.activeEl = target;
    } else {
      config.activeEl = $(config.DEFAULT_SELECTOR);
    }
  }
})();

export default Loading;
